import React from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import {
  Box,
  CircularProgress,
  Typography,
  Button,
  Paper,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import npsfLogoWhite from '../assets/npsf-logo-white.png';
import '../styles/RequestForm.css';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const handleSignIn = () => {
    instance.loginRedirect(loginRequest);
  };

  if (inProgress !== 'none') {
    return (
      <Box
        display='flex'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        minHeight='100vh'
        gap={2}
      >
        <CircularProgress />
        <Typography>Authenticating...</Typography>
      </Box>
    );
  }

  if (!isAuthenticated) {
    return (
      <div id='request-form-root'>
        <div className='blue-section'>
          <img
            src={npsfLogoWhite}
            alt='NPSF Logo'
            style={{ width: '150px', height: 'auto', marginBottom: '1rem' }}
          />
          <h1>Athena Account Migration</h1>
          <p>Sign in to migrate your Athena account</p>
        </div>
        <div className='form-wrapper'>
          <Paper elevation={3} sx={{ padding: '2rem', marginTop: '2rem' }}>
            <Box
              display='flex'
              flexDirection='column'
              alignItems='center'
              gap={3}
              py={2}
            >
              <LockOutlinedIcon sx={{ fontSize: 64, color: '#002855' }} />
              <Typography variant='h5' component='h2' textAlign='center'>
                Sign In Required
              </Typography>
              <Typography
                variant='body1'
                color='text.secondary'
                textAlign='left'
                maxWidth={505}
              >
                To migrate your Athena account, please sign in using your
                existing Athena email address (ending in @athena4p.org or
                @npsalumni.org). This verifies your identity before you can
                update your account information.
              </Typography>
              <Button
                variant='contained'
                size='large'
                onClick={handleSignIn}
                sx={{
                  backgroundColor: '#002855',
                  '&:hover': {
                    backgroundColor: '#003366',
                  },
                  mt: 2,
                  px: 4,
                }}
              >
                Sign In to Continue
              </Button>
              <Box
                sx={{
                  mt: 2,
                  p: 2,
                  backgroundColor: '#f5f5f5',
                  borderRadius: 1,
                  width: '100%',
                }}
              >
                <Typography
                  variant='body2'
                  color='text.secondary'
                  textAlign='center'
                >
                  Need help?Contact: {' '}
                  <a
                    href='mailto:athena@npsfoundation.org'
                    style={{
                      color: '#002855',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                    }}
                  >
                    athena@npsfoundation.org
                  </a>
                </Typography>
              </Box>
            </Box>
          </Paper>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;
